import React, { useState, useEffect } from "react";
import { useMasterSync } from "../../context/MasterSyncContext";

const BAR_DURATION_MS = 60_000;

/**
 * Full-width top bar shown for 60 seconds when master-sync is running ("Importing data...").
 */
const SyncProgressBar: React.FC = () => {
  const { isSyncing } = useMasterSync();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!isSyncing) {
      setProgress(0);
      return;
    }
    setProgress(0);
    const start = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const pct = Math.min(100, (elapsed / BAR_DURATION_MS) * 100);
      setProgress(pct);
      if (pct >= 100) clearInterval(interval);
    }, 250);
    return () => clearInterval(interval);
  }, [isSyncing]);

  if (!isSyncing) return null;

  return (
    <div
      className="w-full flex flex-col bg-white-700 dark:bg-[var(--page)]-900 text-gray-900 dark:text-white shadow-sm"
      role="progressbar"
      aria-valuenow={Math.round(progress)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Importing data"
    >
      <div className="flex items-center justify-center gap-2 px-4 py-1.5">
        <span className="text-xs font-medium text-gray-900 dark:text-white">
          Importing data…
        </span>
      </div>
      <div className="h-1 bg-gray-800 dark:bg-white-700 overflow-hidden">
        <div
          className="h-full bg-[var(--accent)] hover:bg-[var(--indigo2)] transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default SyncProgressBar;
